import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  INQUIRY_ALL,
  INQUIRY_ASSIGNED,
  INQUIRY_COMMENTS,
  INQUIRY_CREATE,
  INQUIRY_ITEM,
  INQUIRY_LIST,
  INQUIRY_PUBLIC_INFO,
  INQUIRY_UPDATE_STATUS,
} from '../constants/actionTypes'

const inquirySelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const inquiryAllSelector = createSelector(inquirySelector, data => data[INQUIRY_ALL])

export const inquiryAssignedSelector = createSelector(inquirySelector, data => data[INQUIRY_ASSIGNED])

export const inquiryCreateSelector = createSelector(inquirySelector, data => data[INQUIRY_CREATE])

export const inquiryItemSelector = createSelector(inquirySelector, data => data[INQUIRY_ITEM])

export const inquiryListSelector = createSelector(inquirySelector, data => data[INQUIRY_LIST])

export const inquiryUpdateStatusSelector = createSelector(inquirySelector, data => data[INQUIRY_UPDATE_STATUS])

export const inquiryCommnetsSelector = createSelector(inquirySelector, data => data[INQUIRY_COMMENTS])

export const inquiryPublicInfoSelector = createSelector(inquirySelector, data => data[INQUIRY_PUBLIC_INFO])
